import { FormInput, FormSectionHeader, FormSelect, Loader } from "@/components";
import useTeamAssignment from "./useTeamAssignment";
import { FormProvider } from "react-hook-form";
import { EMP, NAME, PROJECT_CODE, ROLE, TEAM } from "./consts";
import { Button } from "@/components/ui";
import { Trash2 } from "lucide-react";

const TeamAssignment = () => {
  const {
    form,
    onSubmit,
    requiredFields,
    isAddPending,
    onDeleteRole,
    onAddMoreRole,
    isView,
    roleList,
    isLoadingRoles,
    employeeList,
    isEmployeeLoading,
    isLoadingTeam,
    isDeleteUserRolePending
  } = useTeamAssignment();
  const { errors } = form.formState;
  console.log(form.getValues()[TEAM]);

  return (
    <>
      {isLoadingRoles || isEmployeeLoading || isLoadingTeam ? (
        <Loader />
      ) : (
        <FormProvider {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)}>
            <div className="bg-white mt-[20px] rounded-lg shadow-sm overflow-hidden ">
              <FormSectionHeader className="pt-[25px] px-[30px]">
                Team Info
              </FormSectionHeader>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px] py-[25px] px-[30px]">
                <FormInput
                  name={NAME}
                  control={form.control}
                  label="Project Name"
                  placeholder="Please enter"
                  error={errors[NAME]?.message}
                  isRequired={requiredFields.includes(NAME)}
                  disabled
                />
                <FormInput
                  name={PROJECT_CODE}
                  control={form.control}
                  label="Project Code/ID"
                  placeholder="Please enter"
                  error={errors[PROJECT_CODE]?.message}
                  isRequired={requiredFields.includes(PROJECT_CODE)}
                  disabled
                />
              </div>
              <div className="bg-brown-200 col-span-2 gap-[20px] px-[30px] py-[25px]">
                <div className="grid grid-cols-1 gap-[20px]">
                  {form.watch(TEAM)?.map((_, index: any) => (
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-[20px] items-center w-full">
                      <FormSelect
                        name={`${TEAM}.${index}.${ROLE}`}
                        control={form.control}
                        label="Role"
                        placeholder="Please enter"
                        error={
                          (errors as any)?.[TEAM]?.[index]?.[ROLE]?.message ?? ''
                        }
                        isRequired={requiredFields.includes(
                          `${TEAM}.${ROLE}`
                        )}
                        disabled={isView || !!(form.watch(TEAM) as any)?.[index]?.["userRoleId"]}
                        options={(roleList?.data || [])?.map((data: any) => ({
                          label: data?.name,
                          value: data?.roleId?.toString(),
                        }))}
                      />
                      <FormSelect
                        name={`${TEAM}.${index}.${EMP}`}
                        control={form.control}
                        label="Employee"
                        placeholder="Please enter"
                        error={
                          (errors as any)?.[TEAM]?.[index]?.[EMP]?.message ?? ''
                        }
                        isRequired={requiredFields.includes(
                          `${TEAM}.${EMP}`
                        )}
                        disabled={isView || !!(form.watch(TEAM) as any)?.[index]?.["userRoleId"]}
                        options={(employeeList?.data || [])?.map(
                          (data: any) => ({
                            label: `${data?.fullName}`,
                            value: data?.userId?.toString(),
                          })
                        )}
                      />
                      {!isView && (
                        <Trash2
                          className="stroke-red-600 w-[10%] cursor-pointer"
                          onClick={onDeleteRole(index)}
                        />
                      )}
                    </div>
                  ))}
                </div>
                  {!isView && (
                    <Button onClick={onAddMoreRole} type="button" variant="link" className="mt-3">
                      + Add More
                    </Button>
                  )}              </div>
            </div>
            <div className="flex flex-row justify-end gap-3 py-5">
              <Button type="submit" disabled={isAddPending || isDeleteUserRolePending}>
                {isAddPending || isDeleteUserRolePending && <Loader variant="secondary" />}
                Save
              </Button>
            </div>
          </form>
        </FormProvider>
      )}
    </>
  );
};

export default TeamAssignment;
